// DANS L'OMBRE — Shopify Theme Script

document.addEventListener('DOMContentLoaded', function() {

    var navbar = document.getElementById('navbar');
    var menuToggle = document.getElementById('menuToggle');
    var mobileMenu = document.getElementById('mobileMenu');

    // ───── NAVBAR SCROLL ─────
    if (navbar) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 60) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        }, { passive: true });
    }

    // ───── MOBILE MENU ─────
    if (menuToggle && mobileMenu) {
        menuToggle.addEventListener('click', function(e) {
            e.stopPropagation();
            menuToggle.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
        });

        var mobileLinks = document.querySelectorAll('.mobile-link');
        for (var i = 0; i < mobileLinks.length; i++) {
            mobileLinks[i].addEventListener('click', function() {
                menuToggle.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        }
    }

    // ───── SMOOTH SCROLL (index page anchors) ─────
    var anchors = document.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < anchors.length; i++) {
        anchors[i].addEventListener('click', function(e) {
            var href = this.getAttribute('href');
            if (href === '#') return;
            var target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                var navH = window.innerWidth >= 768 ? 60 : 56;
                var top = target.getBoundingClientRect().top + window.scrollY - navH;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        });
    }

    // ───── ACCORDION ─────
    var accHeaders = document.querySelectorAll('.accordion-header');
    for (var i = 0; i < accHeaders.length; i++) {
        (function(header) {
            header.addEventListener('click', function(e) {
                e.preventDefault();
                var item = header.parentElement;
                var wasOpen = item.classList.contains('open');
                var siblings = item.parentElement.querySelectorAll('.accordion-item');
                for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('open');
                if (!wasOpen) item.classList.add('open');
            });
        })(accHeaders[i]);
    }

    // ───── SCROLL REVEAL (Lookbook) ─────
    var reveals = document.querySelectorAll('.lb-reveal');
  if (reveals.length > 0) {
      if ('IntersectionObserver' in window && !window.Shopify.designMode) {
          var revealObserver = new IntersectionObserver(function(entries) {
              for (var i = 0; i < entries.length; i++) {
                  if (entries[i].isIntersecting) {
                      entries[i].target.classList.add('visible');
                      revealObserver.unobserve(entries[i].target);
                  }
              }
          }, { threshold: 0.15 });
          for (var i = 0; i < reveals.length; i++) {
              revealObserver.observe(reveals[i]);
          }
      } else {
          for (var i = 0; i < reveals.length; i++) {
              reveals[i].classList.add('visible');
          }
      }
  }

    // ───── PRODUCT PAGE: Thumbnail gallery ─────
    var mainImage = document.getElementById('productMainImage');
    var thumbs = document.querySelectorAll('.product-thumb');
    if (mainImage && thumbs.length > 0) {
        for (var i = 0; i < thumbs.length; i++) {
            (function(thumb) {
                thumb.addEventListener('click', function() {
                    mainImage.src = thumb.getAttribute('data-full');
                    for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.remove('active');
                    thumb.classList.add('active');
                });
            })(thumbs[i]);
        }
    }

    // ───── PRODUCT PAGE: Variant selector ─────
    var sizeBtns = document.querySelectorAll('.product-page-details .size-btn, .product-page .size-btn');
    var variantSelect = document.getElementById('variantSelect');
    if (sizeBtns.length > 0 && variantSelect) {
        for (var i = 0; i < sizeBtns.length; i++) {
            (function(btn) {
                btn.addEventListener('click', function() {
                    var optionIndex = parseInt(btn.getAttribute('data-option-index'));
                    var value = btn.getAttribute('data-value');

                    var siblings = btn.parentElement.querySelectorAll('.size-btn');
                    for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('active');
                    btn.classList.add('active');

                    var selectedOptions = [];
                    var allOptionGroups = document.querySelectorAll('.size-options');
                    for (var k = 0; k < allOptionGroups.length; k++) {
                        var activeBtn = allOptionGroups[k].querySelector('.size-btn.active');
                        if (activeBtn) selectedOptions.push(activeBtn.getAttribute('data-value'));
                    }

                    var options = variantSelect.querySelectorAll('option');
                    for (var m = 0; m < options.length; m++) {
                        var optionText = options[m].textContent.trim();
                        var match = selectedOptions.every(function(sel) {
                            return optionText.indexOf(sel) !== -1;
                        });
                        if (match) {
                            variantSelect.value = options[m].value;
                            var addBtn = document.querySelector('.add-to-cart-btn');
                            if (addBtn) {
                                if (options[m].getAttribute('data-available') === 'true') {
                                    addBtn.disabled = false;
                                    addBtn.textContent = 'AJOUTER AU PANIER';
                                } else {
                                    addBtn.disabled = true;
                                    addBtn.textContent = 'EPUISE';
                                }
                            }
                            break;
                        }
                    }
                });
            })(sizeBtns[i]);
        }
    }

    // ───── PRODUCT PAGE: AJAX Add to Cart ─────
    var productForm = document.getElementById('productForm');
    if (productForm) {
        productForm.addEventListener('submit', function(e) {
            e.preventDefault();
            var addBtn = productForm.querySelector('.add-to-cart-btn');
            if (!addBtn || addBtn.disabled) return;

            var variantId = productForm.querySelector('[name="id"]').value;

            addBtn.disabled = true;
            addBtn.textContent = 'AJOUT...';

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
            })
            .then(function(res) { return res.json(); })
            .then(function() {
                addBtn.textContent = 'AJOUTE ✓';
                addBtn.style.background = 'transparent';
                addBtn.style.color = '#FFF';

                var cartCountEl = document.getElementById('cartCountNav');
                if (cartCountEl) {
                    cartCountEl.textContent = parseInt(cartCountEl.textContent) + 1;
                }

                setTimeout(function() {
                    addBtn.textContent = 'AJOUTER AU PANIER';
                    addBtn.style.background = '';
                    addBtn.style.color = '';
                    addBtn.disabled = false;
                }, 1500);
            })
            .catch(function() {
                addBtn.textContent = 'ERREUR';
                setTimeout(function() {
                    addBtn.textContent = 'AJOUTER AU PANIER';
                    addBtn.disabled = false;
                }, 1500);
            });
        });
    }

});
